module.exports = __webpack_public_path__ + "static/media/aacp_star.18845d0a.svg";